import styled from "styled-components";

export const AcordeonContainer = styled.div<{ isOpen: boolean }>`
  width: 100%;
  padding: 0.75rem 1.5rem;
  background-color: ${({ isOpen }) => (isOpen ? "white" : "transparent")};
  display: flex;
  flex-direction: column;
  gap: ${({ isOpen }) => (isOpen ? "0.5rem" : "0")};
  justify-content: center;
  &:hover {
    background-color: #fffa;
    cursor: pointer;
    span > svg {
      color: ${({ theme }) => theme.colors.primaryPurple.main} !important;
    }
  }
`;

export const AcordeonHeader = styled.div<{
  isOpen: boolean;
  selected: boolean;
}>`
  display: flex;

  #title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1rem;
    font-weight: ${({ isOpen }) => (isOpen ? "bold" : "normal")};
    color: #424242;
    align-items: center;
    line-height: 1rem;
    white-space: nowrap;

    svg {
      color: ${({ theme, isOpen, selected }) =>
        isOpen || selected ? theme.colors.primaryPurple.main : "#616161"};
      margin-right: 1.6rem;
    }
  }

  #chevron-icon {
    align-self: center;
    justify-content: center;
    line-height: 1rem;
    vertical-align: middle;
  }
`;

export const AcordeonBody = styled.ul<{ isOpen: boolean }>`
  max-height: ${({ isOpen }) => (isOpen ? "400px" : "0")};
  overflow: auto;
  margin: 0;
  padding: 0;
  transition: max-height ${({ isOpen }) => (isOpen ? "1s" : "0")} ease-in-out;

  & > li:hover {
    transform: scale(1.03);
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar {
    width: 0.4rem;
    height: 0.4rem;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 50px;
    background-color: #bdbdbd;
  }
`;
